import RestClient from '../../../lib/RestClient';

const BASE_URL = '/advanceData';

export function getAllAdvanceDataCustomer(
    sortColumn: String, sortOrder: String, pageToLoad: number, count: number, filter:string, account?: string
) {
    return RestClient.get(BASE_URL + '/customer', {sortBy: sortColumn, sortDirection: sortOrder, page: pageToLoad, count: count, filter: filter, account: account});
}

export function getAllAdvanceDataSupplier(
    sortColumn: String, sortOrder: String, pageToLoad: number, count: number, filter:string, account?: string
) {
    return RestClient.get(BASE_URL + '/supplier', {sortBy: sortColumn, sortDirection: sortOrder, page: pageToLoad, count: count, filter: filter, account: account});
}
